import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="page">
      <div className="page-content" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '4rem', fontWeight: '700' }}>404</h1>
        <p style={{ color: 'var(--color-text-muted)' }}>
          Page not found
        </p>
        <Link to="/" className="btn btn-primary">
          Go Home
        </Link>
      </div>
    </div>
  )
}
